export default __webpack_public_path__ + "static/media/circleLeaderboard-default.edf4d59e.png";